import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import { Selection } from 'types/api/selection.type';

import type { RootState } from '../store';

const selectionsAdapter = createEntityAdapter({
  selectId: (selection: Selection) => selection?.id,
});

export const selectionsSlice = createSlice({
  name: 'selections',
  initialState: selectionsAdapter.getInitialState(),
  reducers: {
    setSelections(state, action) {
      selectionsAdapter.setAll(state, action.payload);
    },
    deleteSelection(state, action) {
      selectionsAdapter.removeOne(state, action.payload);
    },
  },
});

export const getState = (rootState: RootState) => rootState.selections;

export const selectionsSelector = selectionsAdapter.getSelectors(
  (state: RootState) => state.selections
);

export const { setSelections, deleteSelection } = selectionsSlice.actions;
